<template>
  <div>
    <ul class="list-group" id="notice-list">
      <li class="list-group-item" v-for="(item, index) in items.data" :key="index">
        <span class="issue-date">
          <i class="far fa-calendar-alt"></i>
          {{item.issue_date}}
        </span>
        <span>|</span>
        <span class="notice-title-block">
          <a v-if="item.protection=='Y'" @click="unlock(item)" target="_self">
            <span class="locked">
              <i class="far fa-file-alt"></i>
              {{ (lang=='en')?  item.eng_title : item.title }}
              <i class="fas fa-lock"></i>
            </span>
          </a>
          <a v-else :href="'/circulars/'+ item.file_id" target="_self">
            <i class="far fa-file-alt"></i>
               {{ (lang=='en')?  item.eng_title : item.title }}
          </a>
        </span>
      </li>
    </ul>

    <div class="pager clearfix" style="text-align: center;">
      <br />
      <br />
      <div class="arrows" style="float:none;">
        <span v-if="prev==null">
          <img src="/images/arrow_pickup_prev.png" width="8px" />
        </span>
        <a v-else :href="prev">
          <img src="/images/arrow_pickup_prev.png" width="8px" />
        </a>

        <span v-if="next==null">
          <img src="/images/arrow_pickup_next.png" width="8px" />
        </span>
        <a v-else :href="next">
          <img src="/images/arrow_pickup_next.png" width="8px" />
        </a>
      </div>
    </div>

    <b-modal ref="myModalRef" id="modalPopover" hide-footer>
      <div class="d-block text-center">
        <form action="/circulars/showContent" method="post">
          <input type="hidden" name="_token" :value="csrf" />
          <input
            v-if="currentItem != null"
            type="hidden"
            name="passowrd_name"
            :value="currentItem.password"
          />
          <input v-if="currentItem != null" type="hidden" name="id" :value="currentItem.file_id" />
          <div class="d-block text-center" style="padding-top:0px">
            <div class="column is-12">
              <label class="label">
                <h3 v-if="currentItem != null">請輸入{{currentItem.password}}</h3>
              </label>
              <p class="control has-icon has-icon-right">
                <input
                  style="width:100%;"
                  name="password"
                  type="password"
                  placeholder="密碼"
                  required
                />
              </p>
            </div>
          </div>
          <b-btn class="mt-3" type="submit" block>登入</b-btn>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import * as servicesMixin from "../shared/servicesMixin";
// import bModal from "bootstrap-vue/es/components/modal/modal";
import { log } from "util";
export default {
  props: ["items", "lang"],
  // mixins: [servicesMixin],
  data() {
    return {
      prev: null,
      next: null,
      show: false,
      password: "",
      currentItem: null,
      csrf: window.Laravel.csrfToken
    };
  },
  mounted() {
    this.init();
  },
  created: function() {},
  methods: {
    init() {
        console.log("lang", this.lang);
      //   console.log("hello",this.csrf);
      if (this.items) {
        this.prev = this.items.prev_page_url;
        this.next = this.items.next_page_url;
      }
    },
    showModal() {
      // setTimeout(function() {
      this.$refs.myModalRef.show();
      // }, 500);
    },
    hideModal() {
      this.$refs.myModalRef.hide();
    },
    unlock(item) {
      this.show = true;
      this.currentItem = item;
      //   console.log("current item", item);
      this.showModal();
    },
    onReset(evt) {
      evt.preventDefault();
      this.form.password = "";
    }
  }
};
</script>
<style lang="scss">
#notice-list {
  font-size: 18px;

  .issue-date {
    margin-right: 10px;
  }

  .notice-title-block {
    margin-left: 10px;
  }
}

.pager {
  .arrows {
    span {
      opacity: 0.1;
      width: 40px;
      padding: 5px 0;
      background-color: #042304;
      display: inline-block;
      margin-right: 5px;
      text-align: center;

      img {
        max-width: 100%;
        height: auto;
        vertical-align: middle;
      }
    }
    a {
      width: 40px;
      padding: 5px 0;
      background-color: #da7fa9;
      display: inline-block;
      margin-right: 5px;
      text-align: center;
      transition: all 0.5s;
    }

    a::hover {
      //   background-color: rgb(113, 199, 191);
    }
  }
}

.locked {
  /* color: #007bff; */
  cursor: pointer;
}

#modalPopover {
  .modal {
    z-index: 30000 !important;
  }

  .modal-header {
    border-bottom: 0px;
    button {
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// resources/assets/js/mlang/notice/noticeList.vue